import { Trans } from "@lingui/react/macro";
import React from "react";
import {
  DescriptionTextColumnContent,
  DescriptionTextColumnContentLeft,
  DescriptionTextColumnContentRight,
  DescriptionTextColumnTitle,
  SectionContainer,
  DescriptionTextColumn,
  Button,
  ButtonsContainer,
  BlockContentValue
} from "@silversea-ssc/ui-components-react";
import CruiseItineraryPortsSummary from "src/page-components/cruise/CruiseItineraryPortsSummary/CruiseItineraryPortsSummary";
import { SlideshowItem } from "components/Slideshow/Slideshow";
import TextBox from "components/TextBox/TextBox";
import { dequal } from "dequal/lite";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { NewEcommerceButton } from "components/ECommerceButtons";
const ResponsiveSlideshow = React.lazy(
  () => import("components/Slideshow/ResponsiveSlideshow")
);

interface SpecialVoyageSectionItineraryContentProps {
  slideshow?: SlideshowItem[];
  uniqueCountriesCount?: number;
  uniquePortsCount?: number;
  routesCount?: number;
  backgroundColor: "titanium" | "white";

  title?: string;
  description?: BlockContentValue;
  brochureUrl?: string;
  ecommerceStatus?: ECommerceStatus;
}

const SpecialVoyageSectionItineraryContent: React.FC<
  React.PropsWithChildren<SpecialVoyageSectionItineraryContentProps>
> = ({
  slideshow,
  uniqueCountriesCount,
  uniquePortsCount,
  routesCount,
  backgroundColor,
  title,
  description,
  brochureUrl,
  ecommerceStatus
}) => {
  return (
    <SectionContainer
      spacingTop="regular"
      spacingBottom="regular"
      backgroundColor={backgroundColor}
      dataContentName="section_itinerary_content"
    >
      <DescriptionTextColumn>
        <DescriptionTextColumnContent>
          <DescriptionTextColumnContentLeft>
            <DescriptionTextColumnTitle>{title}</DescriptionTextColumnTitle>
            <CruiseItineraryPortsSummary
              ports={uniquePortsCount}
              countries={uniqueCountriesCount}
              routesCount={routesCount}
            />
            <TextBox fontSize="medium" content={description} />

            <ButtonsContainer spacingTop="regular" align="left">
              <NewEcommerceButton
                disableRAQ
                url={ecommerceStatus}
                raqUrl={undefined}
                size="regular"
                inverted
              />
              {brochureUrl && (
                <Button
                  renderAs="a"
                  variant="secondary"
                  href={brochureUrl}
                  target="_blank"
                  rel="noreferrer"
                  dataContentPiece="view_the_brochures"
                  inverted
                >
                  <Trans>View the Brochure</Trans>
                </Button>
              )}
            </ButtonsContainer>
          </DescriptionTextColumnContentLeft>
          <DescriptionTextColumnContentRight>
            {slideshow && slideshow?.length > 0 && (
              <React.Suspense>
                <ResponsiveSlideshow
                  items={slideshow}
                  variant={backgroundColor == "white" ? "gray" : "dark"}
                  dataContentName="slideshow"
                />
              </React.Suspense>
            )}
          </DescriptionTextColumnContentRight>
        </DescriptionTextColumnContent>
      </DescriptionTextColumn>
    </SectionContainer>
  );
};

export default React.memo(SpecialVoyageSectionItineraryContent, dequal);
